import React from "react";
import AboutUsPresenter from "./AboutUsPresenter";
import "./AboutUsPage.css";
import BasePage from "../base/BasePage";
import NavBar1 from "../components/Navbar1";

class AboutUsPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new AboutUsPresenter();
    this.state = {
      showIntroduction: false,
      showMissionVision: false,
      showMilestones: false,
    };
    this.introductionRef = React.createRef();
    this.missionVisionRef = React.createRef();
    this.milestoneRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const triggerPoint = window.innerHeight * 0.7;
    const introductionTop =
      this.introductionRef.current?.getBoundingClientRect().top;
    const missionVisionTop =
      this.missionVisionRef.current?.getBoundingClientRect().top;
    const milestoneTop = this.milestoneRef.current?.getBoundingClientRect().top;

    if (introductionTop < triggerPoint && !this.state.showIntroduction) {
      this.setState({ showIntroduction: true });
    }

    if (missionVisionTop < triggerPoint && !this.state.showMissionVision) {
      this.setState({ showMissionVision: true });
    }

    if (milestoneTop < triggerPoint && !this.state.showMilestones) {
      this.setState({ showMilestones: true });
    }
  };

  render() {
    const { showIntroduction, showMissionVision, showMilestones } = this.state;
    const hero = this.presenter.getHeroSectionContent();
    const intro = this.presenter.getIntroductionContent();
    const mission = this.presenter.getMissionContent();
    const vision = this.presenter.getVisionContent();
    const milestones = this.presenter.getMilestones();
    const milestones1 = this.presenter.getMilestones1();

    return (
      <>
        <NavBar1 className="shadow-sm" />

        {/* Hero Section */}
        <div
          className="hero-section"
          style={{ backgroundImage: `url("${hero.backgroundImage}")` }}
        >
          <div className="hero-overlay" />
          <div className="hero-content">
            <h1 className="fw-bold">{hero.title}</h1>
            <p className="lead">{hero.description}</p>
          </div>
        </div>

        {/* Introduction Section */}
        <div
          ref={this.introductionRef}
          className={`introduction-section ${showIntroduction ? "show" : ""}`}
        >
          <div className="intro-content d-flex flex-wrap justify-content-center">
            <div className="intro-image-wrapper">
              <img
                src={intro.imageSrc}
                alt={intro.imageAlt}
                className="intro-image"
              />
            </div>
            <div className="intro-text">
              <h3 className="fw-bold fst-italic pt-5 text-start">
                {intro.quote}
              </h3>
              <p className="lead text-start">{intro.description}</p>
            </div>
          </div>
        </div>

        {/* Mission and Vision Section */}
        <section ref={this.missionVisionRef} className="mission-vision-section">
          <h2
            className={`fw-bold mb-5 text-center mission-vision-title ${
              showMissionVision ? "show" : ""
            }`}
          >
            Our Mission and Vision
          </h2>

          <div className="d-flex flex-column flex-lg-row gap-5 w-100 mission-vision-cards">
            <div className={`mission-card ${showMissionVision ? "show" : ""}`}>
              <i className={`${mission.iconClass} mb-3 mission-vision-icon`} />
              <h3 className="fw-bold mb-3">{mission.title}</h3>
              <p
                className="lead"
                style={{ fontSize: "16px", lineHeight: "1.6" }}
              >
                {mission.description}
              </p>
            </div>

            <div className={`vision-card ${showMissionVision ? "show" : ""}`}>
              <i className={`${vision.iconClass} mb-3 mission-vision-icon`} />
              <h3 className="fw-bold mb-3">{vision.title}</h3>
              <p
                className="lead"
                style={{ fontSize: "16px", lineHeight: "1.6" }}
              >
                {vision.description}
              </p>
            </div>
          </div>
        </section>

        <section ref={this.milestoneRef} className="journey-section">
          <div
            className={`journey-animated-wrapper ${
              this.state.showMilestones ? "zoom-in" : ""
            }`}
          >
            <h2 className="fw-bold mb-5 text-center journey-title">
              Our Journey of Excellence
            </h2>

            {/* Unified Card */}
            <div className="journey-main-card">
              <div className="journey-year">
                <h1 className="fw-bold m-0">{milestones[0].year}</h1>
              </div>
              <div className="journey-content">
                <h5 className="fw-bold mb-3">{milestones[0].title}</h5>
                <p
                  className="lead"
                  style={{ fontSize: "16px", lineHeight: "1.6" }}
                >
                  {milestones[0].description}
                </p>
              </div>
            </div>

            {/* Milestone Cards */}
            <div className="milestone-cards">
              {milestones.slice(1).map((item, index) => (
                <div key={index} className="milestone-card">
                  <div className="milestone-card-header">
                    <h5 className="fw-bold mb-0">{item.year}</h5>
                  </div>
                  <div className="milestone-card-body">
                    <h5 className="fw-bold mb-2">{item.title}</h5>
                    <p style={{ fontSize: "14px", lineHeight: "1.6" }}>
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="milestone-cards">
              {milestones1.map((item, index) => (
                <div key={index} className="milestone-card">
                  <div className="milestone-card-header">
                    <h5 className="fw-bold mb-0">{item.year}</h5>
                  </div>
                  <div className="milestone-card-body">
                    <h5 className="fw-bold mb-2">{item.title}</h5>
                    <p style={{ fontSize: "14px", lineHeight: "1.6" }}>
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="container footer-container">
            <div className="footer-text fw-bold">
              <i className="bi bi-c-circle"></i>
              <span>2025 Tenth Corporation Inc. All Rights Reserved</span>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default AboutUsPage;
